export const firstImageUrl = (images) => {
  const first = (images || [])[0];
  return first ? first.url || first.src || first : null;
};

export const preloadImage = (url) => {
  if (typeof url === 'string') new Image().src = url;
};
